<div class="flex items-stretch gap-1">
  @if (hasIncrementors && isDecrementorAllowed) {
    <button mat-button aria-label="Previous Week" class="mr-0 !h-auto" (click)="this.decrement()">
      <mat-icon class="!text-3xl/none" [inline]="true">arrow_left</mat-icon>
    </button>
  }

  <mat-form-field class="cursor-pointer" (click)="picker.open()">
    <input
      matInput
      readonly
      tabindex="-1"
      class="cursor-pointer"
      [matDatepicker]="picker"
      [formControl]="weDateControl"
      [matDatepickerFilter]="onlySaturdays"
      (dateChange)="this.emit()"
    />
    <mat-datepicker-toggle matSuffix mat-raised-button [for]="picker" />
    <mat-datepicker #picker />
    <mat-label>Week Ending</mat-label>
  </mat-form-field>

  @if (hasIncrementors) {
    <button mat-button aria-label="Next Week" class="mr-0 !h-auto" (click)="this.increment()">
      <mat-icon class="!text-3xl/none" [inline]="true">arrow_right</mat-icon>
    </button>
  }
</div>
